import { GzEasmAssetsPerWeekWebComponent } from './component/GzEasmAssetsPerWeekWebComponent';

export { GzEasmAssetsPerWeekWebComponent };
